import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { TSS_BLACK, TSS_DARK_BLUE } from 'tss-core-lib-common';

import infoSrc from '../../img/info-i.svg';

var styles = void 0;

var InfoBlock = function InfoBlock(_ref) {
  var ip = _ref.ip,
      tvnId = _ref.tvnId,
      host = _ref.host,
      os = _ref.os,
      browser = _ref.browser,
      ccisVersion = _ref.ccisVersion,
      applicationVersion = _ref.applicationVersion;
  return React.createElement(
    'div',
    { className: 'popup ' + css(styles.popup) },
    tvnId ? React.createElement(
      'div',
      { className: css(styles.popupRow) },
      React.createElement(
        'span',
        { className: css(styles.popupRowLabel) },
        'TvnId'
      ),
      tvnId
    ) : null,
    ip ? React.createElement(
      'div',
      { className: css(styles.popupRow) },
      React.createElement(
        'span',
        { className: css(styles.popupRowLabel) },
        'IP'
      ),
      ip
    ) : null,
    React.createElement(
      'div',
      { className: css(styles.popupRow) },
      React.createElement(
        'span',
        { className: css(styles.popupRowLabel) },
        'Host'
      ),
      host
    ),
    ccisVersion ? React.createElement(
      'div',
      { className: css(styles.popupRow) },
      React.createElement(
        'span',
        { className: css(styles.popupRowLabel) },
        'CCIS Version'
      ),
      ccisVersion
    ) : null,
    applicationVersion ? React.createElement(
      'div',
      { className: css(styles.popupRow) },
      React.createElement(
        'span',
        { className: css(styles.popupRowLabel) },
        'Version'
      ),
      applicationVersion
    ) : null,
    React.createElement(
      'div',
      { className: css(styles.popupRow) },
      React.createElement(
        'span',
        { className: css(styles.popupRowLabel) },
        'Operating System'
      ),
      os
    ),
    React.createElement(
      'div',
      { className: css(styles.popupRow) },
      React.createElement(
        'span',
        { className: css(styles.popupRowLabel) },
        'Browser'
      ),
      browser
    )
  );
};

InfoBlock.propTypes = {
  ip: PropTypes.string,
  tvnId: PropTypes.string,
  host: PropTypes.string,
  os: PropTypes.string,
  browser: PropTypes.string,
  ccisVersion: PropTypes.string,
  applicationVersion: PropTypes.string
};

InfoBlock.defaultProps = {
  ip: 'N/A',
  tvnId: null,
  host: 'N/A',
  os: 'N/A',
  browser: 'N/A',
  ccisVersion: null,
  applicationVersion: null
};

var timezoneStr = function timezoneStr(timezone) {
  return timezone || 'N/A';
};

var HeaderInfo = function HeaderInfo(_ref2) {
  var timezone = _ref2.timezone,
      ip = _ref2.ip,
      tvnId = _ref2.tvnId,
      host = _ref2.host,
      os = _ref2.os,
      browser = _ref2.browser,
      ccisVersion = _ref2.ccisVersion,
      applicationVersion = _ref2.applicationVersion;
  return React.createElement(
    'div',
    { className: css(styles.container) },
    React.createElement(
      'div',
      { className: css(styles.content) },
      timezone ? React.createElement(
        'div',
        { className: css(styles.info) },
        React.createElement(
          'span',
          { className: css(styles.infoLabel) },
          React.createElement(FormattedMessage, { id: 'header.info.timezone.label' })
        ),
        timezoneStr(timezone)
      ) : null
    ),
    React.createElement(
      'div',
      { className: css(styles.icon) },
      React.createElement('img', { src: infoSrc, alt: 'Information' }),
      React.createElement(InfoBlock, {
        ip: ip,
        tvnId: tvnId,
        host: host,
        os: os,
        browser: browser,
        ccisVersion: ccisVersion,
        applicationVersion: applicationVersion
      })
    )
  );
};

HeaderInfo.propTypes = {
  timezone: PropTypes.string,
  ip: PropTypes.string,
  tvnId: PropTypes.string,
  host: PropTypes.string,
  os: PropTypes.string,
  browser: PropTypes.string,
  ccisVersion: PropTypes.string,
  applicationVersion: PropTypes.string
};

HeaderInfo.defaultProps = {
  timezone: null,
  ip: 'N/A',
  tvnId: null,
  host: 'N/A',
  os: 'N/A',
  browser: 'N/A',
  ccisVersion: null,
  applicationVersion: null
};

styles = StyleSheet.create({
  container: {
    fontSize: '1.2rem',
    color: 'rgba(255,255,255,0.6)',
    display: 'flex'
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end'
  },

  infoLabel: {
    fontWeight: 600,
    margin: '0 0.4rem 0 0',
    color: 'rgba(255,255,255,0.8)'
  },

  icon: {
    backgroundColor: 'rgba(255,255,255,0.15)',
    border: 0,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '3.1rem',
    width: '3.1rem',
    margin: '0 0 0 0.8rem',
    position: 'relative',

    ':hover > .popup': {
      display: 'block'
    }
  },

  popup: {
    display: 'none',
    position: 'absolute',
    top: '100%',
    right: 0,
    zIndex: 100,
    backgroundColor: 'white',
    padding: '1.6rem',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.3)',
    fontSize: '1.4rem',
    color: TSS_BLACK,
    width: '40rem'
  },

  popupRow: {
    display: 'flex',
    margin: '0 0 1rem 0',

    ':last-child': {
      margin: 0
    }
  },

  popupRowLabel: {
    width: '35%',
    textTransform: 'uppercase',
    fontSize: '1.2rem',
    paddingTop: '2px',
    color: TSS_DARK_BLUE,
    opacity: 0.5
  }
});

export default HeaderInfo;